import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AppSettings from './AppSettings';

const importPage = document.getElementById('gbi');
const settingsPage = document.getElementById('gbi_settings');

if (importPage) {
  ReactDOM.render(<App />, document.getElementById('gbi'));
}

if (settingsPage) {
  ReactDOM.render(<AppSettings />, document.getElementById('gbi_settings'));
}



// WEBPACK FOOTER //
// ./src/index.js